export default function PendingIcon() {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2553 4L13.3753 5.85784C14.6353 7.09836 15.3333 8.74824 15.3333 10.5037C15.3333 14.1223 12.344 17.0639 8.66667 17.0639V15.7519L6 18.3759L8.66667 21V19.688C13.8127 19.688 18 15.5675 18 10.5037C18 8.04631 17.026 5.73713 15.2553 4Z"
        fill="currentColor"
      />
      <path
        d="M12 2.62406L9.33333 0V1.31203C4.18733 1.31203 0 5.43247 0 10.4963C0 12.9537 0.974 15.2629 2.74467 17L4.62467 15.1422C3.36467 13.9016 2.66667 12.2518 2.66667 10.4963C2.66667 6.87767 5.656 3.9361 9.33333 3.9361V5.24813L12 2.62406Z"
        fill="currentColor"
      />
    </svg>
  );
}
